import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/cblogo.png";

const Container = tw(ContainerBase)`bg-brand1 text-brand5 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-10 h-10 object-cover`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-transparent lg:text-brand5 text-base font-bold hocus:text-brand4 hocus:border-brand3 pb-1 transition duration-300 mt-2 mx-4`;
const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-brand5 hover:text-brand4 transition duration-300 mx-4 font-semibold`}
`;
const logoTitle = "Logo for Clarebrand Hall"

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-brand4`
const MiniFooter = () => {
  return (
    <Container>
      <Content>
        <Row>
          <LogoContainer>
            <LogoImg src={logo} title={logoTitle}/>
            <LogoText>Clarebrand Village Hall</LogoText>
          </LogoContainer>
          <LinksContainer>
            <Link href="/">Home</Link>
            <Link href="/#nav-our-values">Our Values</Link>
            <Link href="/book">Contact Us</Link>
            <Link href="/privacy">Privacy Policy</Link>
            <Link href="/terms">Terms of Service</Link>
            <Link href="/donate">Donate</Link>
          </LinksContainer>
          <SocialLinksContainer>
            <SocialLink title="Facebook" href="https://www.facebook.com/ClarebrandVillageHall/" target="_default">
              Facebook
            </SocialLink>
          </SocialLinksContainer>
          <CopyrightText>
           Copyright &copy; Clarebrand Village Hall Committee, Clarebrand. DG7 3AH (SC008463)
          </CopyrightText>
        </Row>
      </Content>
    </Container>
  );
};

export default MiniFooter;
